var exports = {
  "Z8": "BioEditor.module__emojiButton___MkJKZk",
  "Dg": "BioEditor.module__emojiButtonActive___MkJKZk",
  "h_": "BioEditor.module__description___MkJKZk",
  "EN": "BioEditor.module__editor___MkJKZk",
  "E": "BioEditor.module__characterCountContainer___MkJKZk",
};

module.exports = exports;
